import React, { Component } from "react";
import Button from "../button/Button";
import Dropdown from "../dropdown/Dropdown";
import DropdownMenu from "../dropdown/DropdownMenu";
import DropdownItem from "../dropdown/Dropdownitem";
import DropdownToggle from "../dropdown/DropdownToggle";
import CloudSvg from "../svg/CloudSvg";
import ModeSvg from "../svg/ModeSvg";
import VerticalMore from "./../svg/VerticalMore";
import UserSvg from "./../svg/UserSvg";
import "./toolBox.scss";
class ToolBox extends Component {
  state = {
    isOpen: true,
  };
  handelToggle = () => {
    const isOpen = !this.state.isOpen;
    this.setState({ isOpen });
  };
  render() {
    return (
      <div className="tool_box">
        <div className="tooles">
          <div className="tool_item">
            <a href="/">
              <CloudSvg />
            </a>
          </div>
          <div className="tool_item">
            <a href="/">
              <ModeSvg />
            </a>
          </div>
          <div className="tool_item">
            <Dropdown>
              <DropdownToggle onToggle={this.handelToggle}>
                <VerticalMore />
              </DropdownToggle>
              <DropdownMenu isOpen={this.state.isOpen}>
                <DropdownItem>My Profile</DropdownItem>
                <DropdownItem>Settings</DropdownItem>
                <DropdownItem>Upload</DropdownItem>
                <DropdownItem>Help</DropdownItem>
                <DropdownItem seperator>Sign Out</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <Button href="/" varient="style2">
          <UserSvg />
          Sign In
        </Button>
      </div>
    );
  }
}

export default ToolBox;
